import { render, staticRenderFns } from "./liveChat.vue?vue&type=template&id=1943c38e&scoped=true&"
import script from "./liveChat.vue?vue&type=script&lang=js&"
export * from "./liveChat.vue?vue&type=script&lang=js&"
import style0 from "./liveChat.vue?vue&type=style&index=0&id=1943c38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1943c38e",
  null
  
)

export default component.exports